import { c as _c } from "react/compiler-runtime";
import { useWatch } from 'react-hook-form';
import { generalConfig } from '@sola/config/lib/getters.ts';
export const useNameMaxLengths = () => {
  const $ = _c(3);
  const firstName = useWatch({
    name: "firstName"
  }) ?? "";
  const lastName = useWatch({
    name: "lastName"
  }) ?? "";
  const firstNameLength = firstName.length;
  const lastNameLength = lastName.length;
  const firstNameMaxLength = Math.min(Math.max(generalConfig.leadForms.minMaxFirst, generalConfig.leadForms.combinedMaxLength - lastNameLength), generalConfig.leadForms.firstNameMaxLength);
  const lastNameMaxLength = Math.min(Math.max(generalConfig.leadForms.minMaxLast, generalConfig.leadForms.combinedMaxLength - firstNameLength), generalConfig.leadForms.lastNameMaxLength);
  let t0;
  if ($[0] !== firstNameMaxLength || $[1] !== lastNameMaxLength) {
    t0 = {
      firstNameMaxLength,
      lastNameMaxLength
    };
    $[0] = firstNameMaxLength;
    $[1] = lastNameMaxLength;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};